import { LocalizedEventData } from '@carlito/bookito-client';
import ExperienceCard from '../Card';

type Props = {
  events: LocalizedEventData[];
  openModal(event: LocalizedEventData): void;
  onDate: Date;
};

const ExperienceCardHolder = ({ events, openModal, onDate }: Props) => {
  return (
    <div
      className="bookito-widget__events-list flex max-h-[200px]"
      style={{
        flexFlow: 'inherit',
      }}
    >
      {events.map((event) => (
        <ExperienceCard
          key={event.id}
          event={event}
          openModal={() => openModal(event)}
          onDate={onDate}
        />
      ))}
    </div>
  );
};

export default ExperienceCardHolder;
